<div class="relative gg">
    <div class="relative flex flex-col h-[100vh] overflow-y-scroll right-tag">

        <div class="w-full flex-grow flex items-center mb-10">
            <div class="card-holder mx-auto">
                <div class="block w-full relative p-4">
                    <div class="relative land-container py-3 rounded-2xl">
                        <div class="login-containerrr relative py-4 px-4 rounded-2xl move-up delay-75" style="--order: 10">
                            @if (regComplete) {
                                <div class="px-3 xl:px-20 py-3">
                                    <div class="text-center p-4">
                                        <div class="text-primary-700">
                                            <mat-icon class="!h-[96px] !w-[96px] !text-[96px]">check_circle</mat-icon>
                                        </div>
                                        <div class="text-primary-700 text-3xl py-3">
                                            {{ 'Successful Registered Account' | concat | translate }}
                                        </div>

                                        <div class="px-3 xl:px-10 py-4">
                                            <div class="p-5 bg-white/50">
                                                {{ 'Please proceed to login into your account message' | concat | translate }}
                                            </div>
                                            <div class="pt-3 flex justify-center">
                                                <button
                                                    class="flex px-3 gap-2 justify-center items-center !h-10 rounded-lg !bg-primary text-white"
                                                    type="button"
                                                    [routerLink]="['','login']">
                                                    <mat-icon>arrow_back</mat-icon>
                                                    <span class="block py-2 text-md">{{ 'Continue to Login' | concat | translate }} </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            } @else {
                                <div class="move-up py-4 px-4" *ngIf="!showOtpForm">
                                    <form
                                        (ngSubmit)="register(registerForm.value)"
                                        [formGroup]="registerForm"
                                        autocomplete="off"
                                        novalidate
                                    >
                                        <div class="grid grid-cols-2 gap-2">
                                            <div class="col-span-2 md:col-span-1 move-up">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>{{ 'Firstname' | concat | translate }}</mat-label>
                                                    <input matInput formControlName="firstName" name="firstName" placeholder="{{ 'Firstname' | concat | translate }}" required>
                                                    <mat-error>
                                                        <span *ngIf="!registerForm.get('firstName')?.valid && !registerForm.get('firstName')?.untouched">
                                                            {{ 'Field is required' | concat | translate }}
                                                        </span>
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-span-2 md:col-span-1 move-up">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>{{ 'Middlename' | concat | translate }}</mat-label>
                                                    <input matInput formControlName="middleName" name="middleName" placeholder="{{ 'Middlename' | concat | translate }}">
                                                    <mat-error>
                                                        <span *ngIf="!registerForm.get('middleName')?.valid && !registerForm.get('middleName')?.untouched">
                                                            {{ 'Field is required' | concat | translate }}
                                                        </span>
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-span-2 md:col-span-1 move-up">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>{{ 'Lastname' | concat | translate }}</mat-label>
                                                    <input matInput formControlName="lastName" name="lastName" placeholder="{{ 'Lastname' | concat | translate }}" required>
                                                    <mat-error>
                                                        <span *ngIf="!registerForm.get('lastName')?.valid && !registerForm.get('lastName')?.untouched">
                                                            {{ 'Field is required' | concat | translate }}
                                                        </span>
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <!-- <div class="col-span-2 md:col-span-1 move-up">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>{{ 'Email Address' | concat | translate }}</mat-label>
                                                    <input matInput formControlName="email" name="email" placeholder="{{ 'Email Address' | concat | translate }}" required>
                                                    <mat-error>
                                                        <span *ngIf="!registerForm.get('email')?.valid && !registerForm.get('email')?.untouched">
                                                            {{ 'Field is required' | concat | translate }}
                                                        </span>
                                                    </mat-error>
                                                </mat-form-field>
                                            </div> -->

                                            <div class="col-span-2 md:col-span-1 move-up">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>{{ 'Phone Number' | concat | translate }}</mat-label>
                                                    <input
                                                        matInput formControlName="profilePhone" name="profilePhone" placeholder="{{ 'Phone Number' | concat | translate }}" required
                                                        [showMaskTyped]="true" [dropSpecialCharacters]="false" prefix="255" mask="000000000"
                                                    >
                                                    <mat-error>
                                                        <span *ngIf="!registerForm.get('profilePhone')?.valid && !registerForm.get('profilePhone')?.untouched">
                                                            {{ 'Field is required' | concat | translate }}
                                                        </span>
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-span-2 md:col-span-1 move-up">
                                                <mat-form-field appearance="outline" class="material-form">
                                                    <mat-label> {{ 'Gender' | concat | translate }} </mat-label>
                                                    <mat-select formControlName="gender" placeholder="{{ 'Gender' | concat | translate }}">
                                                        <mat-option *ngFor="let data of genders" [value]="data">
                                                            {{ data | concat | translate }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error>
                                                        <span *ngIf="!registerForm.get('gender').valid && !registerForm.get('gender').untouched">
                                                            {{ 'Field is required' | concat | translate }}
                                                        </span>
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-span-2 md:col-span-1 move-up">
                                                <mat-form-field appearance="outline" class="material-form">
                                                    <mat-label> {{ 'Age Group' | concat | translate }} </mat-label>
                                                    <mat-select formControlName="ageGroup" placeholder="{{ 'Age Group' | concat | translate }}">
                                                        <mat-option *ngFor="let data of AgeRangeArray" [value]="data">
                                                            {{ data | concat | translate }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error>
                                                        <span *ngIf="!registerForm.get('ageGroup').valid && !registerForm.get('ageGroup').untouched">
                                                            {{ 'Field is required' | concat | translate }}
                                                        </span>
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-span-2 move-up mb-3">
                                                <div class="bg-primary-50 rounded-xl p-4 text-center">
                                                    {{ 'Reset Password description and password policy' | concat | translate }}
                                                </div>
                                            </div>

                                            <div class="col-span-2 md:col-span-1 move-up">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>{{ 'Password' | concat | translate }}</mat-label>
                                                    <input matInput formControlName="password" name="password" placeholder="{{ 'Password' | concat | translate }}" [type]="hide ? 'password' : 'text'"/>
                                                    <button
                                                        type="button" mat-icon-button matSuffix (click)="hide = !hide"
                                                        [attr.aria-label]="'Hide'"
                                                        [attr.aria-pressed]="hide"
                                                    >
                                                        <mat-icon class="material-icons-outlined">{{ hide ? 'visibility_off' : 'visibility' }} </mat-icon>
                                                    </button>
                                                    <mat-error>
                                                        <span *ngIf="!registerForm.get('password')?.valid && !registerForm.get('password')?.untouched">
                                                            {{ 'Please use a strong password' | concat | translate }}
                                                        </span>
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="col-span-2 md:col-span-1 move-up">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>{{ 'Confirm Password' | concat | translate }}</mat-label>
                                                    <input matInput formControlName="confirmPassword" name="confirmPassword" placeholder="{{ 'Confirm Password' | concat | translate }}" [type]="hide ? 'password' : 'text'"/>
                                                    <button
                                                        type="button" mat-icon-button matSuffix (click)="hide = !hide"
                                                        [attr.aria-label]="'Hide'"
                                                        [attr.aria-pressed]="hide"
                                                    >
                                                        <mat-icon class="material-icons-outlined">{{ hide ? 'visibility_off' : 'visibility' }} </mat-icon>
                                                    </button>
                                                    <mat-error>
                                                        <span *ngIf="!registerForm.get('confirmPassword')?.valid && !registerForm.get('confirmPassword')?.untouched">
                                                            {{ 'Field is required' | concat | translate }}
                                                        </span>
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="flex gap-2 pt-5 items-center">
                                            <button
                                                class="flex px-3 gap-2 justify-center items-center !h-10 rounded-lg !bg-primary text-white"
                                                type="button"
                                                [routerLink]="['','login']">
                                                <mat-icon>arrow_back</mat-icon>
                                                <span class="block py-2 text-md">{{ 'Back to Login' | concat | translate }} </span>
                                            </button>
                                            <button
                                                [ngClass]="(registerForm?.valid && registerForm.get('password')?.value === registerForm.get('confirmPassword')?.value) ?'!bg-accent text-white':'!bg-grey/50 text-gray-500'"
                                                class="flex-grow flex gap-5 justify-center items-center !h-10 rounded-lg"
                                                type="submit"
                                                [disabled]="!registerForm.valid || loading || registerForm.get('password')?.value != registerForm.get('confirmPassword')?.value">
                                                <span class="block p-2 text-md">{{ 'Register' | concat | translate }} </span>
                                            </button>
                                            <mat-progress-spinner
                                                *ngIf="loading"
                                                color="primary" [diameter]="30" mode="indeterminate"
                                            ></mat-progress-spinner>
                                        </div>
                                    </form>
                                </div>

                                <div class="move-up py-4 px-4 xl:px-20" *ngIf="showOtpForm">
                                    <form
                                        (submit)="verifyOtp(otpForm.value)"
                                        [formGroup]="otpForm"
                                        autocomplete="off"
                                        novalidate
                                    >
                                        <div class="block py-3 mb-4 text-center">
                                            <div class="block bg-primary-50 rounded-lg p-4">
                                                <span class="block pb-2">
                                                    {{'Please enter the One Time Password message' | concat | translate }}
                                                </span>
                                                <span class="text-2xl font-medium text-red-600" *ngIf="otpTimeRemain > 0; else resendOtpView">
                                                    {{ getMinutes(otpTimeRemain) }} : {{ getSeconds(otpTimeRemain) }}
                                                </span>
                                                <ng-template #resendOtpView>
                                                    <span class="block pb-1">
                                                        <button
                                                            mat-raised-button
                                                            color="warn"
                                                            (click)="resendOtp()"
                                                            type="button"
                                                        >
                                                            <span class="uppercase"> {{ 'Resend OTP' | concat | translate }} </span>
                                                        </button>
                                                    </span>
                                                </ng-template>
                                            </div>
                                        </div>

                                        <div class="block py-2 max-w-80 mx-auto">
                                            <mat-form-field appearance="outline">
                                                <mat-label>{{ 'Enter OTP' | concat | translate }}</mat-label>
                                                <input
                                                    matInput formControlName="otp" name="otp" placeholder="{{ 'Enter OTP' | concat | translate }}" required
                                                    class="text-center !text-4xl" [showMaskTyped]="true" mask="0 0 0 0 0 0"
                                                >
                                                <mat-error>
                                                    <span *ngIf="!otpForm.get('otp')?.valid && !otpForm.get('otp')?.untouched">
                                                        {{ 'Field is required' | concat | translate }}
                                                    </span>
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div class="flex gap-2 items-center max-w-96 mx-auto">
                                            <button
                                                [ngClass]="otpForm?.valid ?' !bg-accent text-white':'!bg-grey/50 text-gray-500'"
                                                class="flex-grow flex gap-5 justify-center items-center !h-10 rounded-lg"
                                                type="submit"
                                                [disabled]="!otpForm.valid || loading">
                                                <span class="block p-2 text-md">{{ 'Verify' | concat | translate }} </span>
                                            </button>
                                            <mat-progress-spinner
                                                *ngIf="loading"
                                                color="primary" [diameter]="30" mode="indeterminate"
                                            ></mat-progress-spinner>
                                        </div>
                                    </form>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
